<template>
  <div >
    <div class="box-tab">
      <div id="accordion">
        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{ descCodapp }}
            </h3>
          </div>
          <div id="details1" class="panel-collapse collapse in tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive">
                <div class="detail-block">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['10'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ setYearOutput(indexSelected.dteyreap) }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['20'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ indexSelected.numtime }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['30'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ codempid }} - {{ descCodempid }}</div>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-md-6">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['40'] }}</label>
                      <div class="col-md-6">
                        <div class="form-control readonly-field-color">{{ indexSelected.kpino }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['50'] }}</label>
                      <div class="col-md-6">
                        <div class="detail-text width-100 txtarea-width response-full-width">{{ indexSelected.kpiitem }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['60'] }}</label>
                      <div class="col-md-6">
                       <div class="detail-text width-100 txtarea-width response-full-width">{{ indexSelected.target }}</div>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-md-6">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['70'] }}</label>
                      <div class="col-md-6">
                        <div class="form-control readonly-field-color">{{ indexSelected.v_mtrunit }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['80'] }}</label>
                      <div class="col-md-6">
                        <div class="form-control readonly-field-color">{{ indexSelected.mtrvalue }}</div>
                      </div>
                    </div>
                  </form>
                   <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['90'] }}</label>
                      <div class="col-md-6">
                        <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dtetarg) }}</div>
                      </div>
                    </div>
                  </form>
                   <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRESS1EC2']['100'] }}</label>
                      <div class="col-md-6">
                        <hrms-dropdown  v-model="indexSelected.status"
                                        :options="dropdowns.status[nowLang]"
                                        v-validate="'required'"
                                        data-vv-name="status"
                                        data-vv-value-path="inputTime"
                                        name="status"
                                        :class="{ 'input-error' : errors.has('status') }"
                                        :has-error="errors.has('status')" />
                        <div class="text-error" v-show="errors.has('status')" autofocus>{{ errors.first('status') }}</div>
                      </div>
                    </div>
                  </form>
                </div>
                 <div class="col-md-12">
                  <div class="detail-header"><u>{{ labels['HRESS1EC2']['110'] }}</u></div>
                </div>
              </div>
            </div>
          </div>

          <hrms-table  :columns="detail1Columns"
                       :data="detail.table1"
                       :searchDisp="false"
                       :indexDisp="false"
                       />
          <template>
           <div class="col-md-12">
              <div class="detail-header"><u>{{ labels['HRESS1EC2']['160'] }}</u></div>
            </div>
            <hrms-table :columns="detail2Columns"
                        :data="detail.table2"
                        :searchDisp="false"
                        :addInlineEventBool="true"
                        :editInlineEventBool="true"
                        :deleteInlineEventBool="true"
                        :saveInlineEvent="callSave"
                        :summaryLabel="labels['HRESS1EC2']['210']"
                        :nowLang="nowLang"  />
          </template>
        </div>
      </div>
      <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
      </div>
    </div>


  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hress1e-detail',
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i])
          }
          this.postDetail2Save({ searchIndex: this.searchIndex, indexSelected: this.indexSelected, dataRowsHasFlg: dataRowsHasFlg })
        }
      })
      if (typeof this.errors.errors[0] !== 'undefined') {
        document.getElementsByName(this.errors.errors[0].field)[0].focus()
      }
    }
  },
  watch: {
    detail () {
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'toggle',
    'nowLang',
    'codempid',
    'descCodempid',
    'searchIndex',
    'indexSelected',
    'detail1Columns',
    'detail2Columns',
    'postDetail2Save',
    'dropdowns',
    'descCodapp'
  ]
}
</script>



// WEBPACK FOOTER //
// detail.vue?e554f95a